<template>
<CContainer>
    <CRow>
        <CCol col="12" class="d-flex overflow-auto px-0">
            <CreateBtn @click="showModal" class="mfe-2" />
            <FilterIt class="mfe-2" />
            <SortIt class="min-w-fit-content mr-auto" />
        </CCol>
    </CRow>

    <Table class="mt-2" />

    <CModal :show.sync="modal.show">
        <template #header-wrapper>
            <div></div>
        </template>

        <Form :submit="submit" :shortLink="shortLink" ref="shortLinkForm" class="px-1 pt-3" />

        <template #footer-wrapper>
            <div></div>
        </template>
    </CModal>
</CContainer>
</template>

<script>
import { mapActions } from 'vuex'
import { Table, FilterIt, SortIt, Form } from './partials'

export default {
    name: 'List',

    components: {
        FilterIt,
        SortIt,
        Table,
        Form,
    },

    data() {
        return {
            modal: {
                show: false,
                item: {},
            },
            shortLink: {
                title: '',
                url: '',
                key: null,
            },
        }
    },

    methods: {
        ...mapActions({
            create: 'shortLink/create',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading',
        }),
        showModal() {
            this.resetMsg()
            this.setShowLoading(false)

            this.modal = {item: {}, show: true}
        },
        submit() {
            const shortLinkForm = this.$refs.shortLinkForm
            this.setShowLoading()
            this.resetMsg()

            this.create(this.shortLink).then(() => {
                this.setShowLoading(false)
                shortLinkForm.$refs.form.reset()
                this.modal.show = false
            }).catch(result => {
                if (result.data) {
                    shortLinkForm.$refs.form.setErrors(result.data);
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.' + result.tag),
                    type: 'danger'
                })
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.link::v-deep a.nav-link {
    padding: 1rem 1rem !important;
    color: #4d1498 !important; //text-affili-indigo
    border-color: #4d1498 !important;
    border: none!important;
    border-radius: 5px 5px 0 0!important;
}
.link::v-deep a.nav-link.active {
    background: #4d1498 !important; // bg-affili-indigo
    background: linear-gradient(45deg, #801fdb 0%, #4d1498 100%) !important; // bg-gradient-affili-indigo
    color: #fff!important; //text-white
}
.link::v-deep a.nav-link:focus,
.link::v-deep a.nav-link:hover {
    border: none!important;
    border-radius: 5px 5px 0 0!important;
}
</style>